import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { INestedFormPopulate } from 'Models/BOB/ResponseModels/Life/QuestionSet'
import {
  IPolicyItem,
  RaiseClaimResponse,
  ITicketDetails,
  IProposalDetails,
  IPlanInformationMotor,
  IPlanDetailsMotor,
} from 'Pages/Customer360/types'
import { baseUrlQuery } from 'Services/baseQuery'

interface IdynamicObject {
  [key: string]: any
}

export interface IRaiseEndorsementRequest {
  pas_id: string
  insurance_category: string
  endorsement_type: string
  endorsement_data: IdynamicObject
  changed_fields: IdynamicObject
}

export const bobCMSAPI = createApi({
  reducerPath: 'cmsBOB360',
  baseQuery: baseUrlQuery,
  endpoints: (builder) => ({
    getMotorProposalDetails: builder.query<
      {
        data: IProposalDetails
        message: string
        num_pages: number
        page: number
        status: number
      },
      Record<string, string>
    >({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.MOTOR_GET_PROPOSAL_DETAILS}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),
  

    getMotorPolicyInformation: builder.query<IPlanInformationMotor, IPlanDetailsMotor>({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.GET_POLICY_INFORMATION}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),
  }),
})

export const { useLazyGetMotorPolicyInformationQuery, useGetMotorProposalDetailsQuery } = bobCMSAPI
